module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av469-e708b02a8ef6fa5e7cabcb00cebb288f.jpg";